<div class="lesson-pause-container" [ngClass]="rootClassName">
  <div class="lesson-pause-content container">
    <div class="lesson-pause-stack">
      <h4 class="lesson-pause-title">Paused</h4>
      <div class="vstack gap-3 col-12 col-md-2 mx-auto">
        <button type="button" class="btn btn-outline-secondary lesson-pause-button" (click)="onAction('settings')">Settings</button>
        <button type="button" class="btn btn-outline-secondary lesson-pause-button" (click)="onAction('quit')">Quit</button>
        <button type="button" class="btn btn-outline-secondary lesson-pause-button" (click)="onAction('continue')">Continue</button>
      </div>
    </div>
  </div>
</div>
